const apiUrl = process.env.REACT_APP_API_URL;

const getCoolantTypes = (token, cb) => {
    fetch(`${apiUrl}/coolanttypes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getCoolantTypes;
